import { useEffect, useRef } from 'react';

// biome-ignore lint/suspicious/noExplicitAny: generic default allows use without explicit type param
const usePrevious = <T = any>(value: T): T | undefined => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
